import { toast } from 'react-toastify';

import { type CloudResult } from 'repository/repository';

export const displayErrorMessage = <T>(result: CloudResult<T>) => {
  if (result.error) {
    toast.error(result.error.message);
  }
};
